import { css } from 'lit';

export const iconButtonStyle = css`
    :host .button {
        padding: 10px;

        & .icon,
        & .loading-spinner {
            margin: 0 !important;
        }
        & .text {
            padding: 0 !important;
        }
    }
`;
